import type { Spell } from "../types/leagueDuel";

// ─── Config des sorts ─────────────────────────────────────────────────────────
// Liste des sorts équipables avant le match. Cosmétiques pour l'instant (aucun
// effet sur la simulation). Ajoute/retire des entrées ici librement.
// Le user en équipe exactement SPELL_SLOTS.

export const SPELL_SLOTS = 3;

export const SPELLS: Spell[] = [
  { id: "boost", name: "Sprint", emoji: "⚡", description: "Accélère un joueur." },
  { id: "wall", name: "Mur", emoji: "🧱", description: "Renforce la défense." },
  { id: "curve", name: "Frappe enroulée", emoji: "🌀", description: "Tir difficile à arrêter." },
  { id: "freeze", name: "Gel", emoji: "❄️", description: "Ralentit l'adversaire." },
  { id: "heal", name: "Second souffle", emoji: "💨", description: "Réduit la fatigue." },
  { id: "vision", name: "Vision", emoji: "👁️", description: "Meilleure passe." },
];

export const SPELL_BY_ID: Record<string, Spell> = SPELLS.reduce(
  (acc, s) => ((acc[s.id] = s), acc),
  {} as Record<string, Spell>
);

export const DEFAULT_SPELL_IDS: string[] = ["boost", "wall", "curve"];
